import React, { useEffect, useRef } from "react";
import { createPortal } from "react-dom";
import { useTranslation } from "react-i18next";
import "./DiscoverGallery.css";

function DiscoverGallery({ photos, focusIndex = 0, onClose }) {
  const { t } = useTranslation();
  const trackRef = useRef(null);
  const list = Array.isArray(photos) ? photos.filter((p) => p?.url) : [];

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, [onClose]);

  useEffect(() => {
    const el = trackRef.current?.querySelector(
      `[data-gallery-index="${focusIndex}"]`,
    );
    el?.scrollIntoView({ inline: "center", block: "nearest" });
  }, [focusIndex, list.length]);

  if (!list.length) return null;

  return createPortal(
    <div
      className="discover-gallery-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose?.();
      }}
      role="dialog"
      aria-modal="true"
      aria-label={t("photos.photoAlt", { index: focusIndex + 1 })}
    >
      <button
        type="button"
        className="discover-gallery-close"
        onClick={onClose}
        aria-label={t("photos.close")}
      >
        &times;
      </button>

      <div className="discover-gallery-track" ref={trackRef}>
        {list.map((photo, index) => (
          <article
            key={photo.geohash_id || `${photo.url}-${index}`}
            className="discover-gallery-card"
            data-gallery-index={index}
          >
            <img
              src={photo.url}
              alt={
                photo.user
                  ? `@${photo.user}`
                  : t("photos.photoAlt", { index: index + 1 })
              }
              className="discover-gallery-image"
            />
            <div className="discover-gallery-meta">
              {photo.user ? (
                <span className="discover-gallery-user">@{photo.user}</span>
              ) : null}
              {photo.description ? (
                <span className="discover-gallery-desc">{photo.description}</span>
              ) : null}
            </div>
          </article>
        ))}
      </div>
    </div>,
    document.body,
  );
}

export default DiscoverGallery;
